import { z } from 'zod';
import type { TableEditItem } from '@/components/table/table-edit/types';
import type { PartialUndefinedOrNull } from '@/types/partial';
import { ClienteFiscalPerfil } from '@/features/cliente/types/enum';
import { DestinoNotaFiscal } from '@/features/fiscal/enum/DestinoNotaFiscal';
import { DevolucaoOperacao } from '@/features/fiscal/enum/DevolucaoOperacao';
import { TipoCliente } from '@/features/fiscal/enum/TipoCliente';
import { NotaFiscalTipo } from '@/features/nfe/types/enum';

export const RegraFiscalIbsCbsSchema = z.object({
    rib_cbs_paliqefet: z.number(),
    rib_cbs_pcbs: z.number(),
    rib_cbs_pdif: z.number(),
    rib_cbs_predaliq: z.number(),
    rib_cclasstrib: z.string(),
    rib_cst: z.string().nullable(),
    rib_destino: z.enum(DestinoNotaFiscal).nullable(),
    rib_devolucao_operacao: z.enum(DevolucaoOperacao).nullable(),
    rib_empresa_idpk: z.number(),
    rib_estado_especifico: z.string().nullable(),
    rib_idpk: z.number(),
    rib_motivo: z.number().nullable(),
    rib_mun_paliqefet: z.number(),
    rib_mun_pdif: z.number(),
    rib_mun_pibsmun: z.number(),
    rib_mun_predaliq: z.number(),
    rib_perfil_cliente: z.enum(ClienteFiscalPerfil).nullable(),
    rib_regra_fiscal_idpk: z.number(),
    rib_tipo: z.enum(NotaFiscalTipo).nullable(),
    rib_tipo_cliente: z.enum(TipoCliente).nullable(),
    rib_todos_estados: z
        .enum(['S', 'N', ''])
        .nullable()
        .transform((v) => (v === '' ? null : v)),
    rib_tribcompragov_paliqcbs: z.number(),
    rib_tribcompragov_paliqibsmun: z.number(),
    rib_tribcompragov_paliqibsuf: z.number(),
    rib_tribregular_cclasstribreg: z.string().nullable(),
    rib_tribregular_cstreg: z.string().nullable(),
    rib_tribregular_paliqefetregcbs: z.number(),
    rib_tribregular_paliqefetregibsmun: z.number(),
    rib_tribregular_paliqefetregibsuf: z.number(),
    rib_uf_paliqefet: z.number(),
    rib_uf_pdif: z.number(),
    rib_uf_pibsuf: z.number(),
    rib_uf_predaliq: z.number(),
});

type RegraFiscalIbsCbs = z.infer<typeof RegraFiscalIbsCbsSchema>;

export type RegraFiscalIbsCbsBody = PartialUndefinedOrNull<RegraFiscalIbsCbs> & TableEditItem;
